export enum SectionId {
  ADDITIONAL_ACCESS_INFORMATION = 'additional-access-information',
  CITIZENSHIP_DETAILS = 'citizenship-details',
  CONTRACT_DETAILS = 'contract-details',
  DOCUMENT_UPLOAD = 'document-upload',
  FOREIGN_NATIONAL_INFORMATION = 'foreign-national-information',
  PERSONAL_DETAILS = 'personal-details',
}

export enum DocumentGroupId {
  LEGAL_AND_OTHER_DOCUMENTS = 'legal-and-other-documents',
  PASSPORT = 'passport',
  PIV_TRAINING_CERTIFICATE = 'piv-training-certificate',
  RESIDENCY_DOCUMENT = 'residency-document',
  RESUME = 'resume',
  US_VISA_DOCUMENT = 'us-visa-document',
}

export enum DocumentFieldName {
  LEGAL_DOCUMENTS = 'legalDocuments',
  OTHER_DOCUMENTS = 'otherDocuments',
  PASSPORT = 'passport',
  PIV_TRAINING_CERTIFICATE = 'pivTrainingCertificate',
  RESIDENCY_DOCUMENT = 'residencyDocument',
  RESIDENCY_SUPPORTING_DOCUMENTS = 'residencySupportingDocuments',
  RESUME = 'resume',
  US_VISA_DOCUMENT = 'usVisaDocument',
}
